import authGuard from '@/router/guards/auth-guard'
import checkTokenGuard from '@/router/guards/check-token-guard'
import multiGuard from '@/router/utils/vue-router-multiguard'
import fbRoutes from '@/router/owner/fb'
import webviewRoutes from '@/router/owner/webview'
import userRoutes from '@/router/owner/user'
import instagramRoutes from '@/router/owner/instagram'
import storeRoutes from '@/router/owner/store'
import botRoutes from '@/router/owner/bot'

const ownerRoutes = [
  {
    path: '/dashboard',
    beforeEnter: multiGuard([checkTokenGuard, authGuard]),
    component: () => import(/* webpackChunkName: "owner" */ '@/layouts/full/LayoutFull.vue'),
    children: [
      {
        path: '',
        name: 'owner:home',
        component: () => import(/* webpackChunkName: "owner" */ '@/views/dashboard/Home.vue'),
      },
      {
        path: 'help',
        name: 'owner:help',
        component: () => import(/* webpackChunkName: "help" */ '@/views/help/HelpPosts.vue'),
      },
      {
        path: 'cloud',
        name: 'owner:cloud',
        component: () => import(/* webpackChunkName: "cloud" */ '@/views/media/CloudListStep.vue'),
      },
      {
        path: 'multi-poster',
        name: 'owner:multi-poster',
        component: () => import(/* webpackChunkName: "multi-poster" */ '@/views/multi-poster/MultiPosterPage.vue'),
      },
      ...fbRoutes,
      ...webviewRoutes,
      ...userRoutes,
      ...instagramRoutes,
      ...storeRoutes,
      ...botRoutes,
    ],
  },
]

export default ownerRoutes
